/** Shared donut geometry: percent along the ring (0 at the top, clockwise). */
export const TAU = Math.PI * 2;

export function angleOf(percent: number): number {
  return -Math.PI / 2 + (TAU * percent) / 100;
}

export function ringPoint(
  c: number,
  radius: number,
  percent: number,
): [number, number] {
  const a = angleOf(percent);
  return [c + radius * Math.cos(a), c + radius * Math.sin(a)];
}

export function arcPath(
  c: number,
  outer: number,
  inner: number,
  from: number,
  to: number,
): string {
  const span = to - from;
  if (span <= 0) return "";
  const large = span > 50 ? 1 : 0;
  const [ox0, oy0] = ringPoint(c, outer, from);
  const [ox1, oy1] = ringPoint(c, outer, to);
  const [ix0, iy0] = ringPoint(c, inner, from);
  const [ix1, iy1] = ringPoint(c, inner, to);
  return [
    `M ${ox0} ${oy0}`,
    `A ${outer} ${outer} 0 ${large} 1 ${ox1} ${oy1}`,
    `L ${ix1} ${iy1}`,
    `A ${inner} ${inner} 0 ${large} 0 ${ix0} ${iy0}`,
    "Z",
  ].join(" ");
}
